<template>
    <v-flex class="looking-for">
        <v-flex
            class="error-msg"
            pl-3
            v-if="isError">
            <span> {{errorDescription}} </span>
        </v-flex>
        <v-flex class="relative-position search-parent">
            <v-flex xs12>
                <v-text-field
                    class="looking-for__search"
                    :label="ManageParticipantConstants.SEARCH_FOR_MEMBERS"
                    solo
                    clearable
                    v-model="peopleSearchText"
                    @keyup="getGroupParticipants()"
                    data-qe-id="group_search-for-members"
                    @click:clear="clearPeopleSearch()"
                    prepend-inner-icon="search"></v-text-field>
            </v-flex>
            <v-flex class="looking-for__body inner-scrollbar search-result" v-if="isSearchMembers">
                <status-overlay :action="getGroupMembersAction"></status-overlay>
                <v-layout
                    v-for="(member,i) in groupMembers"
                    :key="i"
                    row
                    wrap
                    class="looking-for__list__row">
                    <v-flex xs6>
                        <v-flex class="looking-for__list__row__item">
                            <v-avatar>
                                <img :src="member.userProfileImageUrl" :onerror="imageErrorFallback(member.fallbackProfileImageUrl)" alt="member">
                            </v-avatar>
                            <strong :data-qe-id="`group_member-search-result_${i}_name`">
                                {{member.firstName}} {{member.lastName}}
                            </strong>
                            <small :data-qe-id="`group_member-search-result_${i}_chapter`">
                                {{member.primaryChapter}}
                            </small>
                        </v-flex>
                    </v-flex>
                    <v-flex xs6 text-xs-right>
                        <v-flex class="looking-for__list__row__actions">
                            <!--<small>{{ManageParticipantConstants.MAKE_ADMINISTRATOR}}</small>-->
                            <span>
                                <v-switch
                                    v-model="member.isAdmin"
                                    :data-qe-id="`group_member-search-result_${i}_confirm-switch`"
                                    @change="confirmAction(ManageParticipantConstants.actions.toggleAdmin, member.isAdmin ? ManageParticipantConstants.ARE_YOU_SURE_TO_ADD_THE_MEMBER_AS_AN_ADMIN : ManageParticipantConstants.ARE_YOU_SURE_TO_REMOVE_THE_MEMBER_AS_AN_ADMIN, member, false)">
                                </v-switch>
                            </span>
                            <i :data-qe-id="`group_member-search-result_${i}_confirm-action`" @click="confirmAction(ManageParticipantConstants.actions.removeMember, ManageParticipantConstants.ARE_YOU_SURE_TO_REMOVE_THE_MEMBER, member)" class="far fa-times-circle pointer"></i>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-flex>
        <v-flex v-if="groupAdminList.length > 0">
            <v-flex class="looking-for__title">
                <span> {{ManageParticipantConstants.MANAGE_GROUP_ADMINISTRATORS}}</span>
            </v-flex>
            <v-card class="panelBlock looking-for__list">
                <v-layout
                    v-for="(member, i) in groupAdminList"
                    :key="i"
                    row
                    wrap
                    class="looking-for__list__row">
                    <v-flex xs6>
                        <v-flex class="looking-for__list__row__item">
                            <v-avatar>
                                <img :src="member.userProfileImageUrl" :onerror="imageErrorFallback(member.fallbackProfileImageUrl)" alt="adminMember">
                            </v-avatar>
                            <strong :data-qe-id="`group_admin-member-search-result_${i}_name`">
                                {{member.firstName}} {{member.lastName}}
                            </strong>
                            <small :data-qe-id="`group_admin-member-search-result_${i}_chapter`">
                                {{member.chapter}}
                            </small>
                        </v-flex>
                    </v-flex>
                    <v-flex xs6 text-xs-right>
                        <v-flex class="looking-for__list__row__actions">
                            <!--<small>{{ManageParticipantConstants.MAKE_ADMINISTRATOR}}</small>-->
                            <span>
                                <v-switch
                                    v-model="member.isAdmin"
                                    :data-qe-id="`group_admin-member-search-result_${i}_switch-action`"
                                    @change="confirmAction(ManageParticipantConstants.actions.toggleAdmin, ManageParticipantConstants.ARE_YOU_SURE_TO_REMOVE_THE_MEMBER_AS_AN_ADMIN, member, true)"></v-switch>
                            </span>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <v-dialog
            v-model="openConfirmationPopup"
            lazy
            absolute
            content-class="post-actions"
            persistent>
            <v-card>
                <v-flex tag="h6"> {{ManageParticipantConstants.CONFIRM}}
                    <v-btn
                        icon
                        @click="cancelDialog()"
                        data-qe-id="close_dialog_btn">
                        <v-icon size="20">close</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex tag="p" v-html="confirmationMessage"></v-flex>

                <v-flex text-xs-right v-if="!isLastAdmin">
                    <v-btn
                        class="primary_btn transparent"
                        @click="cancelDialog()"
                        data-qe-id="cancel_dialog_btn">
                        No
                    </v-btn>
                    <v-btn
                        class="primary_btn"
                        @click="confirmToSave()"
                        data-qe-id="save_dialog_btn">Yes</v-btn>
                </v-flex>
                <v-flex text-xs-right v-if="isLastAdmin">
                    <v-btn
                        class="primary_btn transparent"
                        @click="cancelDialog()"
                        data-qe-id="cancel_dialog_btn">
                        OK
                    </v-btn>

                </v-flex>

            </v-card>
        </v-dialog>

        <v-dialog
            v-model="openIsLastAdminPopup"
            lazy
            absolute
            content-class="looking-for__remove-administrator"
            persistent>
            <v-card>
                <v-flex tag="h6"> {{ManageParticipantConstants.REMOVE_ADMINISTRATOR}}
                    <v-btn
                        icon
                        @click="cancelIsLastAdminDialog()"
                        data-qe-id="close_dialog_btn">
                        <i data-v-208291ac="" class="far fa-times-circle"></i>
                    </v-btn>
                </v-flex>
                <v-flex class="looking-for__remove-administrator__body text-xs-center">
                    <v-flex tag="p" v-html="confirmationMessage"></v-flex>
                    <v-flex text-xs-center>
                        <v-btn
                            class="primary_btn"
                            @click="cancelIsLastAdminDialog()"
                            data-qe-id="cancel_dialog_btn">
                            OK
                        </v-btn>

                    </v-flex>
                </v-flex>

            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import { imageErrorFallback } from "../../../common/utils/utils";
    import { mapGetters, mapActions, mapState } from "vuex";
    import { storeAction } from "../../../store/storeActions.constant";
    import { ManageParticipants } from "../groupConstant.js";
    import StatusOverlay from "../../StatusOverlay/StatusOverlay.vue";
    import { storeGetters } from "../../../store/storeGetters.constant";

    export default {
        name: 'ManageParticipants',
        components: {
            StatusOverlay,
        },
        created() {
            this.getAllCommunityAdminList().then((data) => {
                this.groupAdminList = data;
            });
        },
        data: () => ({
            peopleSearchText: '',
            isError: false,
            errorDescription: '',
            isSearchMembers: false,
            groupMembers: [],
            addedMembersList: [],
            groupAdminList: [],
            ManageParticipantConstants: ManageParticipants,
            openConfirmationPopup: false,
            currentAction: '',
            selectedMember: {},
            confirmationMessage: '',
            timeoutForTypeAhead: null,
            isLastAdmin: false,
            confirmPopupHeader: '',
            isPopupHeader: '',
            openIsLastAdminPopup: false,
        }),
        methods: {
            ...mapActions({
                getMembersList: `group/${storeAction.getCommunityMembers}`,
                toggleGroupMemberAdminPermission: `group/${storeAction.toggleGroupMemberAdminPermission}`,
                getAllCommunityAdminList: `group/${storeAction.getAllCommunityAdminList}`,
                removeGroupMember: `group/${storeAction.removeGroupMember}`,
                getIsLastAdmin: `group/${storeAction.getIsLastAdmin}`,
            }),

            imageErrorFallback,
            confirmAction(action, message, member, clearPeopleSearch = false) {
                this.currentAction = action;
                this.selectedMember = member;
                if (this.groupAdminList.length === 1 && member.id === this.groupAdminList[0].id) {
                    this.getIsLastAdmin().then(() => {
                        this.selectedMember.isAdmin = this.selectedMember.isAdmin === false;
                        this.openIsLastAdminPopup = true;
                        this.confirmationMessage = this.ManageParticipantConstants.LAST_ADMIN_REMOVE_MESSAGE;
                    });
                } else {
                    this.currentAction = action;
                    this.selectedMember = member;
                    this.openConfirmationPopup = true;
                    this.confirmationMessage = message;
                    this.confirmPopupHeader = this.ManageParticipantConstants.CONFIRM;
                }
                if (clearPeopleSearch) {
                    this.clearPeopleSearch();
                }
            },
            cancelDialog() {
                this.openConfirmationPopup = false;
                if (this.currentAction === this.ManageParticipantConstants.actions.toggleAdmin) {
                    this.selectedMember.isAdmin = !this.selectedMember.isAdmin;
                }
            },
            cancelIsLastAdminDialog() {
                this.openIsLastAdminPopup = false;
            },
            confirmToSave() {
                this.openConfirmationPopup = false;
                switch (this.currentAction) {
                    case this.ManageParticipantConstants.actions.removeMember:
                        this.deleteMemberToList(this.selectedMember.id);
                        break;
                    case this.ManageParticipantConstants.actions.toggleAdmin:
                        this.toggleMemberAdminPermission(this.selectedMember);
                        break;
                    default:
                        break;
                }
            },
            getGroupParticipants() {
                if (this.peopleSearchText && this.peopleSearchText.length < 3) {
                    this.groupMembers = null;
                    this.isSearchMembers = false;
                }
                clearTimeout(this.timeoutForTypeAhead);
                this.timeoutForTypeAhead = setTimeout(() => {
                    if (this.peopleSearchText && this.peopleSearchText.length > 2) {
                        this.isSearchMembers = true;
                        this.getMembersList(this.peopleSearchText).then((data) => {
                            this.groupMembers = data.map((member) => {
                                return {
                                    id: member.id,
                                    userProfileImageUrl: member.userProfileImageUrl,
                                    firstName: member.firstName,
                                    lastName: member.lastName,
                                    isAdmin: this.groupAdminList.some(admin => admin.id === member.id),
                                    isMember: member.isMember,
                                    fallbackProfileImageUrl: member.fallbackProfileImageUrl,
                                    primaryChapter: member.chapter,
                                };
                            });
                        });
                    }
                }, 1500);
            },
            async toggleMemberAdminPermission(member) {
                try {
                    await this.toggleGroupMemberAdminPermission({ memberId: member.id, isAdmin: member.isAdmin });
                    if (member.isAdmin) {
                        if (this.groupAdminList && !this.groupAdminList.some(m => m.id === member.id)) {
                            this.groupAdminList.push({
                                id: member.id,
                                userProfileImageUrl: member.userProfileImageUrl,
                                firstName: member.firstName,
                                lastName: member.lastName,
                                isAdmin: true,
                                isMember: member.isMember,
                                fallbackProfileImageUrl: member.fallbackProfileImageUrl,
                                chapter: member.primaryChapter,
                            });
                        }
                    } else {
                        this.groupAdminList.splice(this.groupAdminList.map(e => e.id).indexOf(member.id), 1);
                    }
                } catch (error) {
                    member.isAdmin = !member.isAdmin;
                    this.isError = true;
                    this.errorDescription = this.ManageParticipantConstants.ERROR_WHILE_MANAGING_ADMIN_PERMISSION;
                    setTimeout(() => {
                        this.isError = false;
                        this.errorDescription = '';
                    }, 3000);
                }
            },
            clearPeopleSearch() {
                this.isSearchMembers = false;
                this.peopleSearchText = '';
                this.groupMembers = [];
            },

            deleteMemberToList(memberId) {
                this.removeGroupMember(memberId).then(() => {
                        this.groupMembers.splice(this.groupMembers.map(e => e.id).indexOf(memberId), 1);
                        if (this.groupAdminList.some(admin => admin.id === memberId)) {
                            this.groupAdminList.splice(this.groupAdminList.map(e => e.id).indexOf(memberId), 1);
                        }
                    })
                    .catch(() => {
                        this.isError = true;
                        this.errorDescription = this.ManageParticipantConstants.ERROR_WHILE_REMOVING_MEMBER;
                        setTimeout(() => {
                            this.isError = false;
                            this.errorDescription = '';
                        }, 3000);
                    });
            },

        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                isLastAdminStatus: `group/${storeGetters.isLastAdminStatus}`,
            }),

            getGroupMembersAction() {
                return this.actions[storeAction.getCommunityMembers];
            },
        },
    };
</script>

<style lang="scss">
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/_commonClasses.scss";

    .looking-for {
        .error-msg {
            color: $ypo-red;
            position: relative;
            left: 0;
            top: 5px;
            font-size: 13px;
            margin-bottom: 15px;
        }

        &__body {
            max-height: 350px;
            padding: 15px;
            overflow-y: auto;

            &__list-item {
                position: relative;
                padding: 20px 10px 20px 75px;
                border-bottom: 1px $ypo-medium-gray solid;
                align-items: center;

                &:hover {
                    background: $ypo-open-blue-gray;

                    .__actions {
                        opacity: 1;
                        visibility: visible;
                    }

                    .v-btn {
                        opacity: 1;
                        visibility: visible;
                    }
                }

                &__avatar {
                    position: absolute;
                    left: 10px;
                    top: 16px;
                }

                &__name {
                    font-size: 15px;
                    color: $ypo-dark-background-gray;
                    font-weight: 600;
                    display: block;
                }

                small {
                    display: block;
                    color: $ypo-dark-background-gray;
                }

                .__actions {
                    position: absolute;
                    right: 10px;
                    z-index: 2;
                    top: 16px;
                    opacity: 0;
                    visibility: hidden;
                    transition: 0.5s all ease;

                    .v-icon {
                        color: $ypo_blue !important;
                    }
                }

                .v-btn {
                    position: absolute;
                    right: 10px;
                    z-index: 2;
                    top: 16px;
                    opacity: 0;
                    visibility: hidden;
                    transition: 0.5s all ease;

                    .v-icon {
                        color: $ypo_blue !important;
                    }
                }
            }

            &.invites-someone-result {
                border-bottom: 1px $ypo-medium-gray solid;

            }

            &.search-result {
                width: 100%;
                min-height: 60px;
                background: $white;
                z-index: 1;
                border: 1px $ypo-medium-gray solid;
                border-radius: 3px;
                box-shadow: 0 1px 3px 0 rgba($black, 0.18);
                border: 1px solid rgba($ypo-gray, 0.4) !important;
                padding: 0 15px;
                margin-top: -20px;
                margin-bottom: 40px;
                .overlay {
                    top: 58px;
                    border: 1px solid $ypo-medium-gray;
                    border-radius: 0 3px 0 3px;
                }
            }
        }

        &__title {
            font-size: 15px;
            color: $ypo-blue;
            margin-bottom: 10px;
        }

        &__search {
            .v-input__slot {
                box-shadow: 0 1px 3px 0 rgba($black, 0.18) !important;
                border: 1px solid rgba($ypo-gray, 0.4) !important;
                border-radius: 4px !important;
                margin-bottom: 0;
                padding: 12px 30px !important;

                .theme--light.v-icon {
                    color: $ypo-cta !important;
                    font-size: 30px;
                }

                .v-label {
                    font-size: 14px;
                    font-style: italic;
                    color: $ypo-blue;
                }

                .v-text-field__slot {
                    margin-left: 20px;

                    input {
                        font-size: 14px;
                        font-style: italic;
                        color: $ypo-blue !important;
                    }
                }
            }
        }

        &__list {
            padding: 0 15px 70px 15px;

            &__row {
                border-bottom: 1px solid rgba($ypo-gray, 0.4);
                border-radius: 0 !important;
                align-items: center;
                padding: 10px 0;

                &__item {
                    padding-left: 60px;
                    position: relative;
                    color: $ypo-dark-background-gray;
                    min-height: 48px;

                    .v-avatar {
                        position: absolute;
                        left: 0;
                    }

                    strong {
                        display: block;
                        font-size: 16px;
                        font-weight: bold;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                        line-height: normal;
                        padding-top: 5px;
                    }

                    small {
                        display: block;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                        line-height: normal;
                    }

                }

                &__actions {
                    align-items: center;
                    display: inline-flex;
                    position: relative;
                    padding-right: 20px;

                    i {
                        font-size: 20px;
                        color: $ypo-cta;
                        position: absolute;
                        right: 15px;
                    }
                }

                .v-input--selection-controls {
                    margin: 0 30px;
                    top: 12px;
                    position: relative;
                }
            }
        }

        &__remove-administrator {
            width: 450px;

            .v-card {
                border-radius: 3px;

                h6 {
                    background-color: $ypo-blue;
                    color: $white !important;
                    position: relative;
                    color: $ypo-blue;
                    font-size: 16px;
                    margin: 0;
                    padding: 15px 20px;
                    font-family: 'Raleway', sans-serif;
                    font-weight: 500;

                    .v-btn {
                        padding: 0;
                        width: auto;
                        height: auto;
                        margin: 0;
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        color: $white;
                        font-size: 12px;

                        &:before {
                            background-color: $white;
                        }

                    }
                }
            }

            &__body {
                padding: 30px 40px;

                p {
                    padding: 0 0 25px 0;
                    margin: 0;
                }

            }
        }

    }
</style>
